export const hideColumsDependingOnWindowSize = (dispatch) => {
    if (window.innerWidth >= 670) {
        dispatch({ type: 'RESET_HIDDEN_COLUMNS' });
    }
    if (window.innerWidth <= 670) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['numCourses'], showCustomCols: true });
    }
    if (window.innerWidth <= 545) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['numCourses', 'isActive'], showCustomCols: true });
    }
    if (window.innerWidth <= 410) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['numCourses', 'isActive', 'email'], showCustomCols: true });
    }
}